<template>
  <div>
    <a-row>
      <g-master name="evaluators"
                :endpoint="evaluatorsMaster.endpoint"
                :tableSetup="evaluatorsMaster.tableSetup"
                :parentData="evParentData"
                :modalFieldsSetup="evaluatorsMaster.modalFieldsSetup"
                @params="paramsTable"
      >
        <template slot="customButton">
          <g-btn-excel :endpoint="`${evaluatorsMaster.endpoint}_/downloadExcel`" :params="paramsExcel" fileName="evaluadores"/>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16, 16]">
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="type_evaluator"
                          label="Tipo de evaluador"
                          :formItemConfig="fiOptions"
                          :cache="false"
                          :decorator="['id_type_evaluator', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="rol_competency"
                          label="Rol"
                          :formItemConfig="fiOptions"
                          :params="rol_params"
                          :cache="false"
                          :decorator="['id_rol_competency', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              >
              </g-dropdown>
            </a-col>

            <a-col v-bind="colOptions">
              <g-lookup label="Evaluador"
                        :formItemConfig="fiOptions"
                        :cache="false"
                        endpoint="empleados"
                        :decorator="['id_evaluator', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              >
              </g-lookup>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        evaluatorsMaster: {
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'}
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'}
              }
            ]
          },
          endpoint: 'evaluated',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_t_evaluators'
            },
            columns: [
              {title: 'Código', dataIndex: 'id_evaluator', sorter: true},
              {title: 'Nombre', dataIndex: 'nombre', sorter: true},
              {title: 'Cargo', dataIndex: 'cargo', sorter: true},
              {title: 'Compañía', dataIndex: 'company', sorter: true},
              {title: 'Tipo', dataIndex: 'tipo', sorter: true},
              {title: 'Rol', dataIndex: 'rol', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_type_evaluator'},
            {name: 'id_rol_competency'},
            {name: 'id_evaluator'}
          ]
        },
        paramsT: {}
      }
    },
    props: ['id_employee_evaluated', 'id_evaluation'],
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      evParentData () {
        return {
          id_employee_evaluated: this.id_employee_evaluated,
          id_evaluation: this.id_evaluation
        }
      },
      rol_params () {
        return {id_evaluation: this.id_evaluation}
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.evaluatorsMaster.tableSetup.columns, ...this.evParentData}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Evaluadores.vue